import qwest from 'qwest';

import session from '../services/sessionService.jsx';

import WaterTester from '../models/waterTester.jsx';

let waterTesterApi = {
  getWaterTester(id) {
    return new Promise((resolve, reject) => {
      let tester = session.getWaterTester(id);

      if (tester) {
        resolve(tester);
      } else {
        qwest.get(`/WaterTester?id=${id}`)
          .then((xhr, response) => {
            if (response.success) {
              let wt = WaterTester.fromApiFormat(response.data);

              session.setWaterTester(wt);
              resolve(wt);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          });
      }
    });
  },

  getWaterTesters() {
    return new Promise((resolve, reject) => {
      let testers = session.getWaterTesters();

      if (testers.length > 0) {
        resolve(testers);
      } else {
        qwest.get('/WaterTester/All')
          .then((xhr, response) => {
            if (response.success) {
              testers = response.data.map(x => WaterTester.fromApiFormat(x));
              session.setWaterTesters(testers);
              resolve(testers);
            } else {
              reject(response);
            }
          })
          .catch(err => reject(err));
      }
    });
  },

  saveWaterTesters(testers) {
    return new Promise((resolve, reject) => {
      qwest.post('/WaterTester/All', testers.map(t => t.toApiFormat()))
        .then((xhr, response) => {
          if (response.success) {
            let newTesters = response.data.map(x => WaterTester.fromApiFormat(x));

            session.setWaterTesters(newTesters);
            resolve(newTesters);
          } else {
            reject(response);
          }
        });
    });
  },

  deleteWaterTester(waterTester) {
    return new Promise((resolve, reject) => {
      qwest.delete('/WaterTester', waterTester.toApiFormat())
        .then((xhr, response) => {
          if (response.success) {
            session.deleteWaterTester(waterTester);
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch(err => reject(err));
    });
  },

  saveWaterTester(waterTester) {
    return new Promise((resolve, reject) => {
      qwest.post('/WaterTester', waterTester.toApiFormat())
        .then((xhr, response) => {
          if (response.success) {
            let wt = WaterTester.fromApiFormat(response.data);

            session.setWaterTester(wt);
            resolve(wt);
          } else {
            reject(response);
          }
        })
        .catch(err => reject(err));
    });
  },
};

export default waterTesterApi;
